// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__wrC7g","content":"error_content__u_3PR"};